// extracted by mini-css-extract-plugin
export var author = "Author-module--author--12DFk";
export var link = "Author-module--link--1dqxo";
export var photo = "Author-module--photo--1WT_U";
export var subtitle = "Author-module--subtitle--3HDSh";
export var title = "Author-module--title--2UdHe";